import { DatePipe } from '@angular/common';
var ControlMessagesComponent = /** @class */ (function () {
    function ControlMessagesComponent(datepipe) {
        var _this = this;
        this.datepipe = datepipe;
        this.getValidatorErrorMessage = function (validatorName, validatorValue) {
            var config = {
                'required': 'This field is required',
                'maxlength': "Max length must be " + (validatorValue && validatorValue.requiredLength || ''),
                'minlength': "Min length must be " + (validatorValue && validatorValue.requiredLength || ''),
                'fixLength': "Field length must be " + (validatorValue && validatorValue.requiredLength || ''),
                'email': 'Invalid email',
                'twoDeciamls': 'This field should be up to 2 decimal places',
                'wholeNumber': 'Allowed only whole numbers',
                'min': "Min value must be " + (validatorValue && validatorValue.min !== null ? validatorValue.min : ''),
                'max': "Max value must be " + (validatorValue && validatorValue.max || ''),
                'maxError': "The date cannot be greater than " + _this.datepipe.transform(validatorValue.maxValue, 'MM/dd/yyyy'),
                'minError': "The date cannot be less than " + _this.datepipe.transform(validatorValue.minValue, 'MM/dd/yyyy'),
                'notPositive': 'Not positive',
                'noneUniqueCode': 'The code already in use',
                'passwordsDontMatch': 'Passwords entered does not match',
                'invalidPassword': 'The password is invalid',
                'sectionsTotalWeight': 'Active sections total weight can not be more than 100',
                'unknownError': 'Unknown error'
            };
            if (config[validatorName]) {
                return config[validatorName];
            }
            else {
                return 'Invalid field';
            }
        };
    }
    Object.defineProperty(ControlMessagesComponent.prototype, "errorMessage", {
        get: function () {
            if (this.control) {
                for (var propertyName in this.control.errors) {
                    if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
                        return this.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
                    }
                }
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return ControlMessagesComponent;
}());
export { ControlMessagesComponent };
